import { useAuthUser } from 'react-auth-kit';

export function GetAuthData() {
  const auth = useAuthUser();

  return auth();
}
